import { type MCPServerInfo } from '../../types';

const ResendServer: MCPServerInfo = {
  serverId: 'RESEND',
  name: 'Resend',
  slug: 'resend',
  description: 'Resend MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/resend/mcp-send-email',
    commitSha: '31751bb',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['resendApiKey'],
    properties: {
      resendApiKey: {
        type: 'string',
        description: 'Resend APIKey',
        sensitive: true
      },
      senderEmailAddress: {
        type: 'string',
        description: 'Sender email address',
        sensitive: false
      },
      replyToEmailAddresses: {
        type: 'string',
        description: 'Email addresses to reply to, separated by commas',
        sensitive: false
      }
    }
  }
};

export default ResendServer;
